import { IBreadcrumb } from 'src/design/molecules/PageBreadcrumbs';

export interface IJobBreadcrumbJob {
  id: number;
  name?: string | null;
  jobNumber?: string | null;
}

/**
 * @registry Builds the shared Header breadcrumb trail for a job page: Jobs > "{name} -
 * {number}" (summary) > optional module link > optional current-page leaf. Pass `module`
 * as a linked crumb (e.g. the RFIs list) and `leaf` as the un-linked current page.
 */
export const jobBreadcrumbs = (
  job: IJobBreadcrumbJob,
  module?: IBreadcrumb,
  leaf?: string,
): IBreadcrumb[] => {
  const items: IBreadcrumb[] = [
    { text: 'Jobs', href: '/jobs' },
    {
      text: `${job.name} - ${job.jobNumber}`,
      href: `/jobs/${job.id}/summary`,
    },
  ];
  if (module) items.push(module);
  if (leaf != null) items.push({ text: leaf });
  return items;
};
